export default __webpack_public_path__ + "static/media/homeBottomImage.6fc24328.png";